import { Component, EventEmitter, OnInit, Output, signal } from '@angular/core';
import { ComplianceCollection } from 'app/classes/compliance/compliance-collection';
import { APIService } from 'app/shared/api.service';
import { AssetService } from 'app/shared/asset.service';
import moment from 'moment';

@Component({
  selector: 'app-compliance-home',
  templateUrl: './compliance-home.component.html',
  styleUrls: ['./compliance-home.component.css'],
  standalone: false
})
export class ComplianceHomeComponent implements OnInit {

  @Output()
  onComplianceRetrieved: EventEmitter<ComplianceCollection> = new EventEmitter();

  tabIndex = 0;

  compliance = signal<ICompliance>({ current: null, previous: null });

  asset: any;

  constructor(private assetService: AssetService, private apiService: APIService) {

  }

  handleChange(event: any) {

  }

  ngOnInit(): void {
    this.getCurrent();
  }

  getCurrent() {
    const df = moment().startOf('month').toDate();
    const dt = moment().toDate();

    this.apiService.getCompliance(df, dt)
      .then(r => {

        this.compliance.set({ current: r, previous: null });
        this.onComplianceRetrieved.emit(r);
        this.getPrevious();
      });
  }

  getPrevious() {
    const df = moment().subtract(1, 'month').startOf('month').toDate();
    const dt = moment().subtract(1, 'month').endOf('month').toDate();

    this.apiService.getCompliance(df, dt)
      .then(r => {
        this.compliance.update(c => {
          c.previous = r;

          return c;
        });

      });
  }

  select(asset) {
    this.assetService.getAsset(asset.id).then(a => this.asset = a);
  }
}


export interface ICompliance {
  current: ComplianceCollection;
  previous: ComplianceCollection;
}
